import { gql } from "@apollo/client";

export const LoginCredentialsMutation = gql`
  mutation LoginCredentials(
    $username: String!
    $password: String!
    $region: AWSRegions!
  ) {
    authCredentials(username: $username, password: $password, region: $region) {
      idToken
      accessToken
      refreshToken
    }
  }
`;
